// Vendor Libraries
import { ChangeDetectorRef, ElementRef } from '@angular/core';
import Highcharts from 'highcharts';
// Utils / Constants
import { downloadFileFromPostResponse } from 'NewAngular/utils/download';
// Services
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { FundChartService } from 'ChartApp/ts/services/fund-chart.service';
import { ChartZoomService } from 'ChartApp/ts/features/charts-shared/services/chart-zoom.service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { ChartDateZoom } from 'ChartApp/ts/enums/chart-common.enum';
import { CHART_FORMAT_NORMALIZED, FUND_CHART_SYSTEM_DEFAULT_STATE, TOOLTIP_STYLE_BOX, VALID_FUND_CHART_DATE_ZOOM_OPTIONS, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { SINGLE_SERIES_FUND_CHART_OPTIONS } from 'ChartApp/ts/features/single-series-fund-chart/defaults';
import * as i0 from "@angular/core";
import * as i1 from "AccountsApp/ts/services/accounts.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "ChartApp/ts/services/fund-chart.service";
import * as i4 from "@angular/common";
import * as i5 from "@angular/forms";
import * as i6 from "../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i7 from "../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i8 from "../fundamental-chart/components/fundamental-chart.component";
import * as i9 from "../fundamental-chart/components/fund-chart-date-zoom/fund-chart-date-zoom.component";
const _c0 = a0 => ({ "chart-canvas-real": a0 });
const _c1 = () => ({ list: "chart-control-compact" });
const _c2 = a0 => ({ active: a0 });
const _c3 = a0 => ({ backgroundColor: a0 });
function SingleSeriesFundChartComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 6)(1, "label", 21)(2, "input", 22);
    i0.ɵɵlistener("change", function SingleSeriesFundChartComponent_div_5_Template_input_change_2_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleBenchmark()); });
    i0.ɵɵtwoWayListener("ngModelChange", function SingleSeriesFundChartComponent_div_5_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); i0.ɵɵtwoWayBindingSet(ctx_r1.benchmarkSelected, $event) || (ctx_r1.benchmarkSelected = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 23);
    i0.ɵɵelementStart(4, "span", 24);
    i0.ɵɵtext(5, "Show Benchmark Comparison");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("hidden", !ctx_r1.benchmarkId);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.benchmarkSelected);
} }
function SingleSeriesFundChartComponent_div_6_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27)(1, "a", 28);
    i0.ɵɵlistener("click", function SingleSeriesFundChartComponent_div_6_div_2_Template_a_click_1_listener() { const formatOption_r4 = i0.ɵɵrestoreView(_r3).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.setFormat(formatOption_r4)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const formatOption_r4 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(i0.ɵɵpureFunction1(3, _c2, ctx_r1.state.format === formatOption_r4.value));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", formatOption_r4.label, " ");
} }
function SingleSeriesFundChartComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6)(1, "ul", 25);
    i0.ɵɵtemplate(2, SingleSeriesFundChartComponent_div_6_div_2_Template, 3, 5, "div", 26);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.formatOptions);
} }
function SingleSeriesFundChartComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29)(1, "a", 30);
    i0.ɵɵlistener("click", function SingleSeriesFundChartComponent_div_7_Template_a_click_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.exportCSVData()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 31);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("tooltipTitle", "Export Data");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-export");
} }
function SingleSeriesFundChartComponent_div_19_div_1_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "span", 34);
    i0.ɵɵelement(2, "span", 35);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const series_r6 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵstyleMap(i0.ɵɵpureFunction1(3, _c3, series_r6.color));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", series_r6.shortLabel, " ");
} }
function SingleSeriesFundChartComponent_div_19_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵtemplate(1, SingleSeriesFundChartComponent_div_19_div_1_div_1_Template, 4, 5, "div", 33);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const chart_r7 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("hidden", ctx_r1.loadingChart);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", chart_r7);
} }
function SingleSeriesFundChartComponent_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, SingleSeriesFundChartComponent_div_19_div_1_Template, 2, 2, "div", 32);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.tooltipData);
} }
export class SingleSeriesFundChartComponent {
    constructor(accountsService, changeDetector, eltRef, featureService, fundChartService) {
        this.accountsService = accountsService;
        this.changeDetector = changeDetector;
        this.eltRef = eltRef;
        this.featureService = featureService;
        this.fundChartService = fundChartService;
        this.benchmarkId = '';
        this.chartTabUrl = '';
        this.chartTitle = '';
        this.formatOptions = [];
        this.benchmarkDisabled = false;
        this.omittedZoomOptions = [];
        this.securityId = '';
        this.showExportOptions = false;
        this.showLegend = true;
        this.userPreferenceKeys = {};
        this.validZoomOptions = [];
        this.userPreferences = {};
        this.benchmarkSelected = false;
        this.state = FUND_CHART_SYSTEM_DEFAULT_STATE;
        this.chartDataUrl = '';
        this.USER = window.USER;
        this.chartOptions = {};
        this.configurableOptions = {
            dynamicHeight: false,
            showLatestValueLabels: true,
            tooltipStyle: TOOLTIP_STYLE_BOX,
        };
        this.noDataClass = 'get-started-border';
        this.loadingChart = true;
        this.tooltipData = [];
        this.benchmarkId = this.eltRef.nativeElement.getAttribute('benchmarkId');
        this.chartTabUrl = this.eltRef.nativeElement.getAttribute('chartTabUrl');
        this.chartTitle = this.eltRef.nativeElement.getAttribute('chartTitle');
        this.benchmarkDisabled = JSON.parse(this.eltRef.nativeElement.getAttribute('benchmarkDisabled'));
        this.formatOptions = JSON.parse(this.eltRef.nativeElement.getAttribute('formatOptions'));
        this.omittedZoomOptions = JSON.parse(this.eltRef.nativeElement.getAttribute('omittedZoomOptions'));
        // Filter out any omitted zoom options
        this.validZoomOptions = VALID_FUND_CHART_DATE_ZOOM_OPTIONS.filter((option) => {
            return !this.omittedZoomOptions.includes(option.value);
        });
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.showExportOptions = JSON.parse(this.eltRef.nativeElement.getAttribute('showExportOptions'));
        this.showLegend = this.eltRef.nativeElement.getAttribute('showLegend');
        this.userPreferenceKeys = JSON.parse(this.eltRef.nativeElement.getAttribute('userPreferenceKeys'));
        this.chartOptions = SINGLE_SERIES_FUND_CHART_OPTIONS;
    }
    chartDataHandler(chartData) {
        this.loadingChart = !(chartData && Array.isArray(chartData.chart_data) && chartData.chart_data.length > 0);
        // Set up 'tooltipData' for legend unless it is disabled
        if (this.showLegend && !this.loadingChart) {
            this.tooltipData = chartData.chart_data.map((chartDataRow) => {
                return chartDataRow.reduce((acc, chartDataSeries) => {
                    return [
                        ...acc,
                        {
                            color: chartDataSeries.line_format.color,
                            shortLabel: chartDataSeries.long_label,
                        },
                    ];
                }, []);
            });
        }
        // This method changes values that affect the UI.
        // To ensure the UI is updated, mark this component dirty so it is explicitly checked for changes,
        // and then detect changes in this component's view as well as its children.
        // ex: this.loadingChart is used in [hidden] directives in this component's template.
        this.changeDetector.markForCheck();
        this.changeDetector.detectChanges();
    }
    ngOnInit() {
        this.accountsService.getUserPreferences().subscribe({
            next: (preferences) => {
                if (this.userPreferenceKeys.zoom !== undefined) {
                    this.userPreferences.zoom = preferences[this.userPreferenceKeys.zoom];
                }
                if (this.userPreferenceKeys.include_benchmark !== undefined) {
                    this.userPreferences.include_benchmark =
                        preferences[this.userPreferenceKeys.include_benchmark];
                }
                if (this.userPreferenceKeys.format !== undefined) {
                    this.userPreferences.format =
                        preferences[this.userPreferenceKeys.format];
                }
                if (this.userPreferences.format === 'indexed') {
                    // disable 1d zoom option for indexed format
                    this.setOneDayZoomEnabledStatus(false);
                }
            },
            error: () => { },
            complete: () => {
                let userIncludeBenchmarkPreference;
                let includeBenchmark;
                if (this.userPreferences.include_benchmark !== undefined) {
                    userIncludeBenchmarkPreference = this.userPreferences.include_benchmark;
                }
                // Format is either user provided or just the first one from formatOptions
                const format = this.userPreferences.format ?? this.formatOptions[0].value;
                // Now get all the various formatOptions for a given format and save it
                const formatOption = this.formatOptions.find((option) => option.value === format);
                if (this.benchmarkDisabled) {
                    includeBenchmark = false;
                }
                else if (userIncludeBenchmarkPreference === undefined) {
                    // If we do not have include_benchmark preference, include will be true for indexed, false for other
                    includeBenchmark = format === CHART_FORMAT_NORMALIZED;
                    // If we do have a userPreference, include will be user preference for indexed, false for other
                }
                else {
                    includeBenchmark = format === CHART_FORMAT_NORMALIZED ? userIncludeBenchmarkPreference : false;
                }
                this.benchmarkSelected = includeBenchmark;
                // Build initial securities list with primary security
                const securities = [{ id: this.securityId, include: true }];
                // Add the benchmark, with include set to what was determined
                if (this.benchmarkId) {
                    securities.push({
                        id: this.benchmarkId,
                        include: includeBenchmark,
                    });
                }
                // Set up calcs
                const calcs = formatOption.calcs.map((id) => ({
                    id,
                    include: true,
                }));
                const initialState = {
                    calcs,
                    format,
                    securities,
                    zoom: this.userPreferences.zoom,
                };
                this.state = Highcharts.merge({}, this.state, initialState);
                this.setChartDataUrls();
            },
        });
    }
    setFormat(option) {
        this.state.format = option.value;
        // Only check for benchmark in state if benchmark id was supplied
        if (this.benchmarkId) {
            // If we are not in indexed format, make sure benchmark is not visible in chart
            if (this.state.format !== CHART_FORMAT_NORMALIZED) {
                const benchmark = this.state.securities.find((s) => s.id === this.benchmarkId);
                if (typeof benchmark !== 'undefined')
                    benchmark.include = false;
                this.benchmarkSelected = false;
            }
            else {
                // If we are in indexed format, add benchmark to chart if possible
                const benchmarkSelected = this.userPreferences.include_benchmark !== undefined
                    ? this.userPreferences.include_benchmark
                    : true;
                const benchmark = this.state.securities.find((s) => s.id === this.benchmarkId);
                if (typeof benchmark !== 'undefined')
                    benchmark.include = benchmarkSelected;
                this.benchmarkSelected = benchmarkSelected;
            }
        }
        // Get the options for the newly selected format option
        const formatOption = this.formatOptions.find((f) => f.value === this.state.format);
        // Now grab the calcs we are going to display for the new format option
        let calcs = [];
        if (typeof formatOption !== 'undefined') {
            calcs = formatOption.calcs.map((c) => {
                return { id: c, include: true };
            });
        }
        // Set the calcs on the chart state
        this.state.calcs = calcs;
        this.setChartDataUrls();
        // Now that the chart has switched over, set the user preference so we remember this option upon reload
        if (this.USER.authenticated && this.userPreferenceKeys?.format != null) {
            const formatPreferenceParams = {
                [this.userPreferenceKeys.format]: option.value,
            };
            this.accountsService.putUserPreferences(formatPreferenceParams).subscribe({
                next: () => {
                    this.userPreferences.format = option.value;
                    if (option.label === 'Returns') {
                        this.setOneDayZoomEnabledStatus(false);
                        if (this.state.zoom === '1d') {
                            this.setZoom({ label: '5d', value: ChartDateZoom.CHART_ZOOM_FIVE_DAY, enabled: true });
                        }
                    }
                    else {
                        this.setOneDayZoomEnabledStatus(true);
                    }
                },
                error: () => () => {
                    // We don't want to complain if we try to set preferences on an anonymous user and can't
                },
            });
        }
    }
    goToFundChartTab() {
        const queryParams = this.fundChartService.getChartDataUrlQuery(this.state);
        window.location.href = `${this.chartTabUrl}#/?${queryParams}`;
    }
    setOneDayZoomEnabledStatus(enabled) {
        this.validZoomOptions = this.validZoomOptions.map((option) => {
            if (option.value === '1d')
                return { ...option, enabled };
            return option;
        });
    }
    setChartDataUrls() {
        this.chartDataUrl = this.fundChartService.getChartDataUrl(this.state);
    }
    setZoom(zoomOption) {
        this.state.zoom = zoomOption.value;
        this.setChartDataUrls();
        if (this.USER.authenticated && this.userPreferenceKeys?.zoom != null) {
            const zoomPreferenceParams = {
                [this.userPreferenceKeys.zoom]: zoomOption.value,
            };
            this.accountsService.putUserPreferences(zoomPreferenceParams).subscribe({
                next: () => {
                    this.userPreferences.zoom = zoomOption.value;
                },
                error: () => {
                    // We don't want to complain if we try to set preferences on an anonymous user and can't
                },
            });
        }
    }
    toggleBenchmark() {
        if (!this.benchmarkId)
            return;
        const benchmark = this.state.securities.find((s) => s.id === this.benchmarkId);
        if (typeof benchmark !== 'undefined')
            benchmark.include = !benchmark.include;
        this.setChartDataUrls();
        if (this.USER.authenticated && this.userPreferenceKeys?.include_benchmark != null) {
            const benchmarkPreferenceParams = {
                [this.userPreferenceKeys.include_benchmark]: benchmark.include,
            };
            this.accountsService.putUserPreferences(benchmarkPreferenceParams).subscribe({
                next: () => {
                    this.userPreferences.include_benchmark = benchmark.include;
                },
                error: () => {
                    // We don't want to complain if we try to set preferences on an anonymous user and can't
                },
            });
        }
    }
    exportCSVData() {
        this.fundChartService.getChartCSVDataFromState(this.state).subscribe({
            next: (csvDataResponse) => {
                if (csvDataResponse.ok) {
                    downloadFileFromPostResponse(csvDataResponse);
                }
            },
            error: () => { },
        });
    }
}
SingleSeriesFundChartComponent.ɵfac = function SingleSeriesFundChartComponent_Factory(t) { return new (t || SingleSeriesFundChartComponent)(i0.ɵɵdirectiveInject(i1.AccountsService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.FundChartService)); };
SingleSeriesFundChartComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SingleSeriesFundChartComponent, selectors: [["ycn-single-series-fund-chart"]], features: [i0.ɵɵProvidersFeature([ChartZoomService])], decls: 24, vars: 24, consts: [[1, "panel", "panel-data"], [1, "panel-header"], [1, "panel-title"], [1, "panel-actions", "user-select-none"], ["class", "panel-action", 4, "ngIf"], ["class", "panel-action chart-actions", 4, "ngIf"], [1, "panel-action"], ["href", "javascript:void(0)", 1, "btn", "btn-text", 3, "click"], [1, "panel-content"], [1, "chart-cover"], [1, "chart-interactive"], [1, "chart-item", "user-select-none"], [1, "chart-options", "text-uppercase"], [1, "chart-legend", "legend-off-chart", 3, "hidden"], [1, "chart-legend-item"], [1, "chart-legend-item-title"], [4, "ngIf"], [1, "chart-wrap"], [1, "chart-canvas"], [3, "selectZoomOptionHandler", "hidden", "zoomOptions", "zoom", "customCssClasses"], [1, "chart-canvas", "d-flex", "flex-column", 3, "clickEvent", "chartDataHandler", "chartId", "chartOptions", "configurableOptions", "chartDataUrl", "noDataClass"], [1, "custom-control", "custom-checkbox", 3, "hidden"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "ngModelChange", "ngModel"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "nav", "nav-tabs"], ["class", "nav-item", 4, "ngFor", "ngForOf"], [1, "nav-item"], ["href", "javascript:void(0)", 1, "nav-link", 3, "click"], [1, "panel-action", "chart-actions"], ["href", "javascript:void(0)", "ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", 3, "click", "tooltipTitle"], ["ycnIcon", "", 3, "name"], ["class", "chart-legend legend-off-chart", 3, "hidden", 4, "ngFor", "ngForOf"], ["class", "chart-legend-item", 4, "ngFor", "ngForOf"], [1, "chart-legend-item-title", "chart-bullet"], [1, "chart-bullet-point"]], template: function SingleSeriesFundChartComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h3", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "div", 3);
        i0.ɵɵtemplate(5, SingleSeriesFundChartComponent_div_5_Template, 6, 2, "div", 4)(6, SingleSeriesFundChartComponent_div_6_Template, 3, 1, "div", 4)(7, SingleSeriesFundChartComponent_div_7_Template, 3, 2, "div", 5);
        i0.ɵɵelementStart(8, "div", 6)(9, "a", 7);
        i0.ɵɵlistener("click", function SingleSeriesFundChartComponent_Template_a_click_9_listener() { return ctx.goToFundChartTab(); });
        i0.ɵɵtext(10, "View Full Chart");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(11, "div", 8)(12, "div", 9)(13, "div", 10)(14, "div", 11)(15, "div", 12)(16, "div", 13)(17, "div", 14);
        i0.ɵɵelement(18, "span", 15);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(19, SingleSeriesFundChartComponent_div_19_Template, 2, 1, "div", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(20, "div", 17)(21, "div", 18)(22, "ycn-fund-chart-date-zoom", 19);
        i0.ɵɵlistener("selectZoomOptionHandler", function SingleSeriesFundChartComponent_Template_ycn_fund_chart_date_zoom_selectZoomOptionHandler_22_listener($event) { return ctx.setZoom($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "ycn-fundamental-chart", 20);
        i0.ɵɵlistener("clickEvent", function SingleSeriesFundChartComponent_Template_ycn_fundamental_chart_clickEvent_23_listener() { return ctx.goToFundChartTab(); })("chartDataHandler", function SingleSeriesFundChartComponent_Template_ycn_fundamental_chart_chartDataHandler_23_listener($event) { return ctx.chartDataHandler($event); });
        i0.ɵɵelementEnd()()()()()()()();
    } if (rf & 2) {
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.chartTitle);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.state.format === "indexed" && ctx.benchmarkId && !ctx.benchmarkDisabled);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.formatOptions.length > 1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.showExportOptions);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("hidden", !(ctx.loadingChart && (!ctx.state.format || ctx.state.format === "indexed")));
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.state.format === "indexed");
        i0.ɵɵadvance(2);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(19, _c0, ctx.state.format === "real"));
        i0.ɵɵadvance();
        i0.ɵɵproperty("hidden", ctx.loadingChart)("zoomOptions", ctx.validZoomOptions)("zoom", ctx.state.zoom)("customCssClasses", i0.ɵɵpureFunction0(21, _c1));
        i0.ɵɵadvance();
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(22, _c0, ctx.state.format === "real"));
        i0.ɵɵproperty("chartId", "simpleFundChart")("chartOptions", ctx.chartOptions)("configurableOptions", ctx.configurableOptions)("chartDataUrl", ctx.chartDataUrl)("noDataClass", ctx.noDataClass);
    } }, dependencies: [i4.NgForOf, i4.NgIf, i5.CheckboxControlValueAccessor, i5.NgControlStatus, i5.NgModel, i6.IconDirective, i7.TooltipDirective, i8.FundamentalChartComponent, i9.FundChartDateZoomComponent], encapsulation: 2 });
